<template>
  <div class="advertiser-report-search">
    <el-button
      class="colPopover"
      slot="reference"
      type="default"
      @click="openDialog">
      自定义列
    </el-button>

    <el-dialog
      class="search-column-dialog"
      title="自定义列"
      :visible.sync="showDialog"
      v-if="showDialog"
      width="400px"
      :close-on-click-modal="false">

      <div class="filter">
        <div class="panel">
          <div class="panel-heading">
            细分维度
          </div>

          <div class="panel-body">
            <div>
              时间维度
            </div>
            <el-radio-group v-model="value.timeDimension" >
              <el-radio v-for="it in timeDimensionList" :label="it.id" :key="it.id">{{it.name}}</el-radio>
            </el-radio-group>

            <div>
              属性维度
            </div>

            <el-checkbox-group v-model="value.dimensionIds" style="display: inline-block">
              <el-checkbox v-for="it in dimensionList" :label="it.id" :key="it.id">{{it.name}}</el-checkbox>
            </el-checkbox-group>

          </div>
        </div>
      </div>

      <hr color="#EAEFED" />

      <el-row>
        <div class="btn-group">
          <el-button class="btn-search" @click="showDialog = false" plain>取消</el-button>
          <el-button class="btn-search" @click="saveDimension">确定</el-button>
        </div>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import _ from "lodash";

export default {
  props: {
    value: {
      type: Object,
      default: function () {
        return {
          dimensionIds: [],
          timeDimension: 0
        }
      }
    }
  },
  data: function () {
    return {
      showDialog: false,
      timeDimensionList: [
        {id: 1, name: '天'},
        {id: 2, name: '周'},
        {id: 3, name: '月'}
      ],
      dimensionList: [
        {id: 3, name: '媒体'},
        {id: 2, name: '广告位'},
        {id: 1, name: '平台'},
      ]
    };
  },
  computed: {
    items: function () {
      let items = _.cloneDeep(this.columnFilters || []);
      let disabledNames = this.disabledNames || [];
      let hideNames = this.hideNames || [];
      let requiredDimensions = this.requiredDimensions || [];
      for (let item of items) {
        let filters = item.filters;
        let ids = filters.map((t) => t.id);
        item.value = this.cols.filter((t) => ids.indexOf(t) >= 0);
        filters
          .filter((t) => disabledNames.indexOf(t.id) >= 0)
          .forEach((t) => {
            t.disabled = true;
          });
        filters
          .filter((t) => hideNames.indexOf(t.id) >= 0)
          .forEach((t) => {
            if (!(requiredDimensions.indexOf(t.id) >= 0)) {
              t.show = false;
            } else {
              t.show = true;
              t.disabled = true;
            }
          });
      }
      return items;
    },
  },
  methods: {
    openDialog: function () {
      this.showDialog = true;
    },
    saveDimension: function () {
      this.$emit("saveDimension")
      this.showDialog = false
    },
  },
};
</script>
<style scoped>
.colPopover {
  background-color: white;
  height: 30px;
}
.colPopover >>> span {
  color: #999999;
  font-size: 14px;
  margin-top: 1px;
}
.search-column-dialog >>> .el-dialog__title {
  font-size: 16px;
  color: #333733;
}
.search-column-dialog >>> .el-dialog__body {
  padding-top: 6px;
  padding-bottom: 16px;
}
.data-column-sort {
  width: 217px;
  background-color: #eaefed;
  padding-left: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  font-size: 16px;
  color: #333733;
}
.filter {
  overflow-x: hidden;
  overflow-y: scroll;
}
.column {
  margin-top: 5px;
  margin-right: 5px;
  height: 27px;
  background-color: #f9faf9;
}

.close-button {
  float: right;
  padding-right: 8px;
  line-height: 27px;
}
.btn-search {
  width: 86px;
  height: 34px;
}
.btn-group {
  float: right;
  padding-top: 19px;
}
.checkbox {
    margin: 0;
    width: 135px;
    padding-bottom: 2px;
    line-height: 30px;
  }
  .panel {
    background-color: #fff;
  }
  .panel-heading {
    font-size: 16px;
    color: #333733;
    background-color: #EAEFED;
    padding: 3px 15px;
  }
  .panel-body {
    padding: 12px 0 5px 20px;
  }
  .panel-body >>> .el-checkbox__label {
    padding-left: 5px
  }
  .panel-heading >>> .el-checkbox__label {
    padding-left: 5px
  }
  
</style>